import Req from '../../$axios';

const serviceModule = {
  login(params) {
    return Req({
      url: '/login', // 接口名
      method: 'post',
      isJSON: true,
      // tip: '登录中...', // true 默认 请稍等...;  不传参数,无提示;  传 String , 则提示为为String
    }, params);
  },
  loginOut(params) {
    return Req({
      url: '/index/login',
      method: 'post',
      tip: 'loginOut...',
    }, params);
  },
  getMenu(params) {
    return Req({
      url: 'user-analysis-cms/main/index', // 接口名
      method: 'post',
      tip: false, // true 默认 请稍等...;  不传参数,无提示;  传 String , 则提示为为String
    }, params);
  },
  getLoginStatus(params) { // 获取登录状态
    return Req({
      url: 'user-analysis-cms/login/getLoginStatus', // 接口名
      method: 'post',
      tip: false, // true 默认 请稍等...;  不传参数,无提示;  传 String , 则提示为为String
    }, params);
  },
  getMenuListPage(params) {
    return Req({
      url: 'user-analysis-cms/sysMenu/get', // 获取所有菜单
      method: 'post',
      tip: false, // true 默认 请稍等...;  不传参数,无提示;  传 String , 则提示为为String
    }, params);
  },
  addMenu(params) {
    return Req({
      url: 'user-analysis-cms/sysMenu/add', // 新增菜单
      method: 'post',
      tip: false, // true 默认 请稍等...;  不传参数,无提示;  传 String , 则提示为为String
      isJSON: false,
    }, params);
  },
  editMenu(params) {
    return Req({
      url: 'user-analysis-cms/sysMenu/update', // 编辑菜单
      method: 'post',
      tip: false, // true 默认 请稍等...;  不传参数,无提示;  传 String , 则提示为为String
    }, params);
  },
  deleteMenu(params) {
    return Req({
      url: 'user-analysis-cms/sysMenu/delete', // 删除菜单
      method: 'post',
      tip: false, // true 默认 请稍等...;  不传参数,无提示;  传 String , 则提示为为String
    }, params);
  },
  changePass(params) {
    return Req({
      url: 'user/updatepassword', // 修改密码
      method: 'post',
      tip: false, // true 默认 请稍等...;  不传参数,无提示;  传 String , 则提示为为String
    }, params);
  },
  getReceiveAccountList(params) {
    return Req({
      url: 'user-analysis-cms/common/getReceiveAccountList', // 修改密码
      method: 'post',
      tip: false, // true 默认 请稍等...;  不传参数,无提示;  传 String , 则提示为为String
    }, params);
  },
};
export default {
  ...serviceModule
};
